import React, { useState, useEffect, useMemo } from "react";
import {
  Alert,
  Breadcrumb,
  Col,
  Collapse,
  Drawer,
  Flex,
  List,
  message,
  Row,
  Segmented,
  Table,
} from "antd";
import {
  ChevronRightIcon,
  PlusIcon,
  WarningIcon,
} from "../../../assets/icons/icons";
import { CustomTitle } from "../../../components";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import TimesTable from "../../../components/TimesTable";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import map from "../../../assets/images/airline-map.png";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { GoogleMapsProvider } from "../../../components/GoogleMapsProvider";

import airportjson from "../../Airports/airportjson2.json";
import unitedAirlinejson from "../../Airports/unitedAirlineData.json";
import testjson from "../../Airports/test.json";
import json245 from "../../Airports/UAairports_245.json";
import { useSpin } from "../../../components/SpinContext";
import CustomTabs from "../../../components/CustomTabs";
import TabsContent from "./TabsContent";
import AirlinesDetail from "./AirlinesDetail";
import SWminimumTime from "./SWminimumTime";
import UATabsContent from "./UATabsContent ";
import { GetAirportsContacts, GetAirportsData } from "../../../api's/airports";
import { useToken } from "../../../common/helper";

const SWformatBusinessHours = (data) => {
  const dayMap = {
    MON: "Monday",
    TUE: "Tuesday",
    WED: "Wednesday",
    THU: "Thursday",
    FRI: "Friday",
    SAT: "Saturday",
    SUN: "Sunday",
  };

  if (!Array.isArray(data)) return [];

  return data.map((item) => {
    const { is24HourFacility, dayOfWeek, startTime, endTime } = item || {};

    const hasValidTimes = startTime && endTime;
    const is24Hours = is24HourFacility === "true";

    return {
      key: dayOfWeek || "unknown",
      day: dayMap[dayOfWeek] || dayOfWeek || "Unknown Day",
      hours: is24Hours
        ? "24 hours"
        : hasValidTimes
          ? formatTimeRange(startTime, endTime)
          : "Schedule Not Available",
    };
  });
};

// Helper function to format time from 'HHMM' to 'HH:MM AM/PM'
const formatTimeRange = (start, end) => {
  const formatTime = (time) => {
    let hour = parseInt(time.substring(0, 2), 10);
    let minute = time.substring(2);
    let ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${minute} ${ampm}`;
  };

  return `${formatTime(start)} – ${formatTime(end)}`;
};

const DeltaAirline = () => {
  const { showSpin, hideSpin } = useSpin();
  const { token, removeToken } = useToken();
  const navigate = useNavigate();
  const { airlineName } = useParams();
  const location = useLocation();
  const airport = location.state?.airport;
  const airline = location.state?.airline;
  const onChange = (key) => {
    console.log(key);
  };

  const unauthorize = (status) => {
      if (status === 401) {
        removeToken();
        navigate("/login");
      }
    };
    const [contactsList, setContactsList] = useState([]);
  
    // Fetch all contacts
    const GetAllContacts = () => {
      showSpin();
      let  query = `?airport=${airport?.IATA}&airline=${airline?.name}`
      GetAirportsContacts(query, token)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data.data?.is_success) {
              // console.log('all conteact form server : ' , data?.data?.data)
              if (data?.data?.data && data?.data?.data?.length > 0) {
                setContactsList(data?.data?.data);
              }
            } 
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    };
    useEffect(() => {
      GetAllContacts();
    }, []);

  // console.log("airport : ", airport);
  // console.log("245 : ", json245);

  const [data, setData] = useState({
    operationHours: [],
    latLng: { lat: null, lng: null },
    address: {},
    facilityInfo: [],
    dropOffTime: [],
    firmsCode: "",
    portCode: "",
    IRS_Number: "",
    businessHours: [],
    pickUp: [],
    phone_number: "" || "N/A",
    SWbusinessHours: [],
    AAcargoDropoff: [],
    AAcargoPickup: [],
  });


  const [UAdata, setUAData] = useState({
    operationHours: [],
    latLng: { lat: null, lng: null },
    address: {},
    facilityInfo: [],
    product_information: [],
    contactInfo:[],
  });

  // console.log('data : ', data)
  const [AAaddress, setAAadress] = useState({
    pp: {},
    cargo: {},
  });

  // Fetch data from the API on page load

  // Delta airline
  const fetchDeltaAirlineData = () => {
    showSpin();
    // fetch(
    //   `https://www.deltacargo.com/Cargo/data/WWF/getData?station=${location.state?.airport?.code || ""
    //   }`
    // ) 
    let query = `${airport?.IATA}/airlines/?type=${2}`
    GetAirportsData(query, token)
      // .then((response) => response.json())
      .then((result) => {
        console.log("Delta   response  :", result);
        hideSpin();
        const lat = result?.data?.data?.data?.[0]?.latitude ?? 0;
        const lng = result?.data?.data?.data?.[0]?.longitude ?? 0;

        setData({
          operationHours: result?.data?.data?.data[0]?.hourOfOperation || [],

          latLng: { lat, lng },

          address:
            Array.isArray(result?.data?.data?.data?.[0]?.generalStationList) &&
              result.data.data?.data[0].generalStationList.length > 0
              ? result.data.data?.data[0].generalStationList[0]
              : {},

          firmsCode: result?.data?.data?.data?.[0]?.firmsCode || "",

          portCode: result?.data?.data?.data?.[0]?.portCode || "",

          facilityInfo: result?.data?.data?.data?.[0]?.facilityInfo
            ? result.data.data?.data[0].facilityInfo
            : [],

          dropOffTime: result?.data?.data?.data[0]?.dropOffMap || [],

          IRS_Number: result?.data?.data?.data?.[0]?.IRS || "",

          businessHours: [], // for AA (empty array as placeholder)
          SWbusinessHours: [],
          pickUp: [], // for AA (empty array as placeholder)
          SWminTime: [],
          AAcargoDropoff: [],
          AAcargoPickup: [],
        });
      })
      .catch((err) => {
        hideSpin();
        message.error(err);
      });
  };

  // american airline
  const fetchAmericanAirlineData = () => {
    showSpin();
    // fetch(
    //   `https://www.aacargo.com/ua/facilities/${location.state?.airport?.code || ""
    //   }`
    // )
    let query = `${airport?.IATA}/airlines/?type=${1}`
    GetAirportsData(query, token)
      // .then((response) => response.json())
      .then((results) => {
        const result = results?.data?.data || {};
        console.log("american   response  :", result?.data);

        hideSpin();
        // Extract coordinates
        const lat = result?.data?.cargoAddress?.coordinates?.latitude ?? 0;
        const lng = result?.data?.cargoAddress?.coordinates?.longitude ?? 0;
        setAAadress({
          pp: result.data?.ppsAddress,
          cargo: result.data?.cargoAddress,
        });

        setData({
          operationHours:
            Array.isArray(result?.data?.cargoPickup) &&
              result.data.cargoPickup.length > 0
              ? result.data.cargoPickup[0]?.hours || "N/A"
              : "N/A",
          latLng: { lat, lng },
          address: {
            locationAddress:
              result?.data?.cargoAddress?.line_1 || "Unknown Address",
          },
          firmsCode: result?.data?.facilityCustomsDto?.firmsCode || "N/A",
          portCode: result?.data?.facilityCustomsDto?.usPortCode || "N/A",
          facilityInfo: Array.isArray(result?.data?.cargoMiscInfo)
            ? result.data.cargoMiscInfo.map((item) => ({
              attributes: item?.catName || "Unknown",
              indicator: item?.catValue || "N/A",
            }))
            : [],

          // dropOffTime: Array.isArray(result?.data?.domDropOffCutOffTime)
          //   ? result.data.domDropOffCutOffTime.reduce((acc, item) => {

          //     acc[item?.serviceType || "Unknown"] = {
          //       domPrescreenedTime: item?.screenedTime || "N/A",
          //       domMinDropOffTime: item?.unScreenedTime || "N/A",
          //       intPrescreenedTime: "N/A", // Placeholder for future updates
          //       intMinDropOffTime: "N/A",
                
          //     };
          //     return acc;
          //   }, {})
          //   : {},

            dropOffTime: Array.isArray(result?.data?.domDropOffCutOffTime)
  ? result.data.domDropOffCutOffTime.reduce((acc, item) => {
      const serviceType = item?.serviceType || "Unknown";

      // Find matching international record by serviceType
      const intlMatch = Array.isArray(result?.data?.intlDropOffCutOffTime)
        ? result.data.intlDropOffCutOffTime.find(
            (intlItem) => intlItem?.serviceType === serviceType
          )
        : null;

      acc[serviceType] = {
        domPrescreenedTime: item?.screenedTime || "N/A",
        domMinDropOffTime: item?.unScreenedTime || "N/A",
        intPrescreenedTime: intlMatch?.screenedTime || "N/A",
        intMinDropOffTime: intlMatch?.unScreenedTime || "N/A",
      };

      return acc;
    }, {})
  : {},



            

          businessHours: result?.data?.facilityCustomsDto?.businessHours || [],
          SWbusinessHours: [],
          SWminTime: [],
          IRS_Number: result?.data?.facilityCustomsDto?.irsNumber || "N/A",
          
          // pickUp: Array.isArray(result?.data?.domPickUpCutOffTime)
          //   ? result.data.domPickUpCutOffTime
          //   : [],

            pickUp: (() => {
              const domestic = Array.isArray(result?.data?.domPickUpCutOffTime)
                ? result.data.domPickUpCutOffTime
                : [];
            
              const international = Array.isArray(result?.data?.intlPickUpCutOffTime)
                ? result.data.intlPickUpCutOffTime
                : [];
            
              // Merge international data into domestic using serviceType
              const merged = domestic.map((domItem) => {
                const intlMatch = international.find(
                  (intlItem) => intlItem?.serviceType === domItem?.serviceType
                );
            
                return {
                  serviceType: domItem?.serviceType || "Unknown",
                  screenedTime: domItem?.screenedTime || "N/A",      // US Domestic
                  unScreenedTime: intlMatch?.screenedTime || "N/A",  // International
                };
              });
            
              return merged;
            })(),
            

          AAcargoDropoff: result?.data?.cargoDropOff || [],
          AAcargoPickup: result?.data?.ppsPickup || [],
        });
      })
      .catch((err) => {
        hideSpin();
        message.error(err);
      });
  };

  // SouthWest airline
  const fetchSouthWestAirlineData = () => {
    showSpin();
    // fetch(`https://cargoapi.swab2b.com/v1/facilities`)
    let query = `${airport?.IATA}/airlines/?type=${3}`
    GetAirportsData(query, token)
      // .then((response) => response.json())
      .then((resp) => {
        console.log("southwest   response  :", resp);
        // const result = resp?.find(
        //   (item) => item?.airportCodeIATA === airport?.IATA
        // );

        const result = resp?.data?.data?.data || {};
        
        console.log("southwest   response  :", result);
        hideSpin();
        // Extract coordinates
        const lat =
          result?.data?.cargoAddress?.coordinates?.latitude ?? 34.0522;
        const lng =
          result?.data?.cargoAddress?.coordinates?.longitude ?? -118.2437;

        setData({
          operationHours:
            Array.isArray(result?.facilityInfo?.operatingHours) &&
              result?.facilityInfo?.operatingHours > 0
              ? result?.facilityInfo?.operatingHours || "N/A"
              : "N/A",
          latLng: { lat, lng },

          address: {
            locationType: result?.facilityInfo?.facilityType,
            locationAddress:
              result?.facilityInfo?.facilityName +
              "  " +
              result?.facilityInfo?.location?.streetAddress1 +
              " " +
              result?.facilityInfo?.location?.cityName +
              "," +
              result?.facilityInfo?.location?.stateName +
              " " +
              result?.facilityInfo?.location?.zipCode || "Unknown Address",
          },
          firmsCode:
            result?.facilityInfo?.facilityCapabilityInfo?.firmsCode || "N/A",
          portCode:
            result?.facilityInfo?.facilityCapabilityInfo?.customsPortCode ||
            "N/A",
          facilityInfo: [
            {
              attributes:
                result?.facilityInfo?.facilityCapabilityInfo?.facilityResources,
              indicator: "Yes",
            } || [],
          ],
          dropOffTime: Array.isArray(result?.data?.domDropOffCutOffTime)
            ? result.data.domDropOffCutOffTime.reduce((acc, item) => {
              acc[item?.serviceType || "Unknown"] = {
                domPrescreenedTime: item?.screenedTime || "N/A",
                domMinDropOffTime: item?.unScreenedTime || "N/A",
                intPrescreenedTime: "N/A", // Placeholder for future updates
                intMinDropOffTime: "N/A",
              };
              return acc;
            }, {})
            : {},
          SWbusinessHours: result?.facilityInfo?.operatingHours || [],

          SWminTime: result?.facilityHandlingTime || [],

          IRS_Number: result?.data?.facilityCustomsDto?.irsNumber || "N/A",
          phone_number: result?.facilityInfo?.location?.phoneNumber || "N/A",
          pickUp: Array.isArray(result?.data?.domPickUpCutOffTime)
            ? result.data.domPickUpCutOffTime
            : [],

          AAcargoDropoff: [],
          AAcargoPickup: [],
        });
      })
      .catch((err) => {
        hideSpin();
        message.error(err);
      });
  };

  // console.log('test JSON : ', testjson)
  // United airline
  const fetchUnitedAirlineData = () => {
    // console.log('united data : ' , unitedAirlinejson)
    showSpin();
    try {
      const result = json245?.find(
        (item) => item?.IATA === airport?.IATA
      );
      // console.log("resp united :", result);
      // console.log("United Airline response  :", result);
      // const result = testjson;
      hideSpin();
      // Extract coordinates
      const lat = result?.latitude ?? 34.0522;
      const lng = result?.longitude ?? -118.2437;

      setUAData({
        operationHours: result?.operatingHours ? result?.operatingHours : "N/A",
        latLng: { lat, lng },

        address: result?.facilityAddress,
        facilityInfo: [
          {
            attributes:
              result?.facilityInfo?.facilityCapabilityInfo?.facilityResources,
            indicator: "Yes",
          } || [],
        ],
        product_information: result?.product_information || [],
        contactInfo: result?.contactInfo || [],
      });

      const capabilitiesFormatted = Array.isArray(result?.capabilities)
        ? result.capabilities.map((item) => {
          const key = Object.keys(item)[0];
          const formattedKey = key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
          return {
            attributes: formattedKey,
            indicator: "Yes", // or "Available" or whatever you prefer
          };
        })
        : [];

      setData({
        latLng: { lat, lng },
        operationHours: [],
        address: { locationAddress: result?.facilityAddress },
        facilityInfo: capabilitiesFormatted,

      });
    } catch {
      hideSpin();
      message.error("Error fetching United Airline data");
    }
  };

  useEffect(() => {
    if (airline?.name == "Delta Airlines") {
      fetchDeltaAirlineData();
    }

    if (airline?.name == "American Airlines") {
      fetchAmericanAirlineData();
    }

    if (airline?.name == "Southwest Airlines") {
      fetchSouthWestAirlineData();
    }
    if (airline?.name == "United Airlines") {
      fetchUnitedAirlineData();
    }
  }, []);

  const renderHours = (categoryData) => {
    return (
      <List
        className="zl-opening-hours-list zl-custom-collapse-data"
        dataSource={Object.entries(categoryData).map(([day, times]) => ({
          day,
          // Ensure times is always an array before calling join()
          time: Array.isArray(times) ? times.join(", ") : times || "N/A", // If it's not an array, fallback to times as is or "N/A"
          closed: false, // Assuming no closed status in your data, update accordingly if required
        }))}
        renderItem={(item) => (
          <List.Item>
            <Flex align="center" style={{ width: "100%" }}>
              <span className="list-item">{item.day}</span>
              <div className="zl-badge-item">
                <time className="list-item">{item.time}</time>
              </div>
            </Flex>
          </List.Item>
        )}
      />
    );
  };

  // Dynamically render collaps data
  const items = Object.entries(data?.operationHours).map(
    ([category, categoryData], index) => ({
      key: String(index),
      label: category, // Using category name as the label
      children: renderHours(categoryData), // Using the transformed category data
    })
  );

  // console.log("data :", data);

  const [summaryDrawerOpen, setSummaryDrawerOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 991);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 991);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const breadcrumbItems = [
    {
      title: "Airports",
      href: "/airport-list",
    },
    {
      title: airport?.name,
      href: `/airport/${airport?.code}`,
      state: { airport },
    },
    {
      title: airline?.name,
    },
  ];

  const containerStyle = {
    width: "100%",
    height: "208px",
    borderRadius: "12px 12px 0 0", // Top border-radius only
    overflow: "hidden",
  };

  const center = {
    lat: parseFloat(data?.latLng?.lat) || 0,
    lng: parseFloat(data?.latLng?.lng) || 0,
  };

  // american airline table data

  // Helper function to convert abbreviated day to full day name
  const getFullDayName = (abbreviation) => {
    const dayNames = {
      MON: "Monday",
      TUE: "Tuesday",
      WED: "Wednesday",
      THU: "Thursday",
      FRI: "Friday",
      SAT: "Saturday",
      SUN: "Sunday",
    };
    return dayNames[abbreviation] || abbreviation;
  };
  const columns = [
    {
      title: "",
      dataIndex: "day",
      key: "day",
      render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    {
      title: "",
      dataIndex: "hours",
      key: "hours",
      align: "right",
    },
  ];

  // Function to generate table data from businessHours
  const generateTableData = (businessHours) => {
    const result = [];

    businessHours?.forEach((hourBlock, blockIndex) => {
      hourBlock.days.forEach((day, dayIndex) => {
        result.push({
          key: `${blockIndex}-${dayIndex}`,
          day: getFullDayName(day),
          hours: hourBlock.times[0] || "N/A",
        });
      });
    });

    return result;
  };
  const dataSource = generateTableData(data?.businessHours);

  // Southwest airline operating hours
  const SWcolumns = [
    {
      title: "Day",
      dataIndex: "day",
      key: "day",
      align: "left",
    },
    {
      title: "Hours",
      dataIndex: "hours",
      key: "hours",
      align: "right",
    },
  ];

  const SWdataSource = SWformatBusinessHours(data?.SWbusinessHours);


  // Updated function to generate table data
  // const USgenerateTableData = (operatingHours) => {
  //   if (!operatingHours) return [];

  //   const result = [];

  //   dayOrder.forEach((day) => {
  //     const value = operatingHours[day];

  //     if (typeof value === "string") {
  //       // Example: "24 Hours" or "Closed"
  //       result.push({
  //         key: day,
  //         day: day,
  //         hours: value || "N/A",
  //       });
  //     } else if (typeof value === "object" && value !== null) {
  //       // Example: {start: "08:00", end: "15:00"}
  //       result.push({
  //         key: day,
  //         day: day,
  //         hours: formatTimeRange(value.start, value.end),
  //       });
  //     } else {
  //       result.push({
  //         key: day,
  //         day: day,
  //         hours: "N/A",
  //       });
  //     }
  //   });

  //   return result;
  // };

  // const UAdataSource = USgenerateTableData(data?.operationHours);

  const onChanges = (key) => {
    console.log(key);
  };

  const itemss = [
    data?.AAcargoDropoff?.[0] && {
      key: "1",
      label: `${data.AAcargoDropoff[0].type || ""} - ${data.AAcargoDropoff[0].name || ""
        }`,
      children: (
        <TabsContent
          data={data.AAcargoDropoff[0].hours || []}
          address={AAaddress?.cargo || {}}
        />
      ),
    },
    data?.AAcargoDropoff?.[1] && {
      key: "2",
      label: `${data.AAcargoDropoff[1].type || ""} - ${data.AAcargoDropoff[1].name || ""
        }`,
      children: (
        <TabsContent
          data={data.AAcargoDropoff[1].hours || []}
          address={AAaddress?.cargo || {}}
        />
      ),
    },
    data?.AAcargoPickup?.[0] && {
      key: "3",
      label: `${data.AAcargoPickup[0].type || ""} - ${data.AAcargoPickup[0].name || ""
        }`,
      children: (
        <TabsContent
          data={data.AAcargoPickup[0].hours || []}
          address={AAaddress?.pp || {}}
        />
      ),
    },
  ].filter(Boolean); // ⬅️ This removes any `false` or `undefined` items

  const [selectedTab, setSelectedTab] = useState("dropoff");


  const [currentTabsData, setCurrentTabsData] = useState({});

  const UATabsItemss = useMemo(() => 
    Object.entries(UAdata?.product_information || {})
      .map(([key, tab], index) => {
        if (!tab) return null; // Safety check
        return {
          key: String(index),
          label: `${tab?.name || ""}`,
          tabData: tab, // Save original data
          children: (
            <UATabsContent
              data={tab || {}}
            />
          ),
        };
      })
      .filter(Boolean),
    [UAdata?.product_information] // Only recompute when product_information changes
  );

  // ✅ Updated useEffect to run when UATabsItemss changes
  useEffect(() => {
    if (UATabsItemss.length > 0) {
      setCurrentTabsData(UATabsItemss[0]);
    }
  }, [UATabsItemss]);

  const onUAChanges = (key) => {
    const currentTab = UATabsItemss.find(item => item.key === key);
    setCurrentTabsData(currentTab);
    // console.log('Current tab data:', currentTab);
  };


  // console.log("UATabsItemss:", UATabsItemss);
  // console.log("currentTabsData:", currentTabsData);





  return (
    <section className="airline-detail">
      <Row gutter={[24, 36]}>
        {/* left side service hours and time  */}
        <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
          <Flex vertical gap={16}>
            <Breadcrumbs items={breadcrumbItems} />
            <Flex vertical gap={airline?.name != "American Airlines" && 24}>
              <Flex vertical gap={4}>
                <CustomTitle
                  className="zl-custom-title"
                  text={airport?.name}
                  fontSize="24px"
                  fontWeight="700"
                  lineHeight="32px"
                  color="black"
                  marginBottom="0"
                />
                <CustomTitle
                  text={airline?.name}
                  fontSize="18px"
                  fontWeight="700"
                  lineHeight="24px"
                  color="#5E5E5E"
                  marginBottom="0"
                  marginTop="0"
                />
                {!isDesktop && (
                  <button
                    className="zl-custom-btn"
                    onClick={() => setSummaryDrawerOpen(true)}
                  >
                    Summary
                  </button>
                )}
              </Flex>
              <Flex vertical gap={12}>
                {airline?.name !== "American Airlines" &&
                  <CustomTitle
                    text="Operating hours"
                    fontSize="16px"
                    fontWeight="600"
                    lineHeight="20px"
                    color="black"
                    marginBottom="0"
                    marginTop="0"
                  />
                }

                {airline?.name == "United Airlines" && (
                  <>
                  {UATabsItemss?.length > 0 ?
                  <div className="zl-custom-tabs">
                    <CustomTabs
                      defaultActiveKey="1"
                      items={UATabsItemss}
                      onChange={onUAChanges}
                      />
                  </div>
                  :
                  <p style={{color:'#989898', padding:'20px', fontSize:'12px', textAlign:'center', pointerEvents:'none'}}> Data not available </p>

}
                      </>
                )}

                {airline?.name == "American Airlines" && (
                  <div className="zl-custom-tabs" style={{ marginTop: "10px" }}>
                    <CustomTabs
                      defaultActiveKey="1"
                      items={itemss}
                      onChange={onChanges}
                    />
                  </div>
                )}
                {airline?.name == "Delta Airlines" ? (
                  <>
                  {items?.length > 0 ? 
                  <Collapse
                  className="zl-custom-collapse"
                  items={items}
                  onChange={onChange}
                  />
                  :
                  <p style={{color:'#989898', fontSize:'12px', textAlign:'center', pointerEvents:'none'}}> Operating hours not available </p>
                  }
                    </>
                ) : (
                  <>
                    {airline?.name == "Southwest Airlines" ? (
                      <Table
                      className="zl-custom-times-table"
                        columns={SWcolumns}
                        dataSource={SWdataSource}
                        pagination={false}
                        showHeader={false}
                        bordered={true}
                        size="middle"
                        style={{ borderRadius: "8px" }}
                      />
                    ) : (
                      <>
                        {airline?.name !== "American Airlines" && airline?.name !== "United Airlines" ? (
                          <Table
                             className="zl-custom-times-table"
                            columns={columns}
                            dataSource={dataSource}
                            pagination={false}
                            showHeader={false}
                            bordered={true}
                            size="middle"
                            style={{ borderRadius: "8px" }}
                          />
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </Flex>

              {airline?.name == "Southwest Airlines" ? (
                <SWminimumTime data={data?.SWminTime} />
              ) : (
                <>
                  {airline?.name == "American Airlines" ? (
                    <>
                      <Flex
                        // gap={10}
                        align="center"
                        justify="space-between"
                        wrap
                        style={{ marginBottom: "10px", marginTop: "20px" }}
                      >
                        <CustomTitle
                          text="Minimum times"
                          fontSize="16px"
                          fontWeight="600"
                          lineHeight="20px"
                          color="black"
                          marginTop="15px"
                        />
                        <Segmented
                          className="zl-custom-segmented"
                          value={selectedTab}
                          onChange={setSelectedTab}
                          options={[
                            { label: "Dropoff", value: "dropoff" },
                            { label: "Pickup", value: "pickup" },
                          ]}
                        />
                      </Flex>
                      <TimesTable
                        data={
                          selectedTab == "dropoff"
                            ? data?.dropOffTime
                            : data?.pickUp
                        }
                        selectedTab={selectedTab}
                      />
                    </>
                  ) : (
                    <>
                      {airline?.name != 'United Airlines' &&
                        <Flex vertical gap={12}>
                          <CustomTitle
                            text="Minimum dropoff times"
                            fontSize="16px"
                            fontWeight="600"
                            lineHeight="20px"
                            color="black"
                            marginBottom="0"
                            marginTop="0"
                          />
                          <TimesTable
                            data={data?.dropOffTime}
                            selectedTab="dropoff"
                          />
                        </Flex>}
                    </>
                  )}
                </>
              )}

              {/* Unite Airlines  common operating hours  */}
              {/* {airline?.name == "Unite Airlines" && (
                <>
                  <CustomTitle
                    text="Operating hours"
                    fontSize="16px"
                    fontWeight="600"
                    lineHeight="20px"
                    color="black"
                    marginBottom="0"
                    marginTop="0"
                  />
                  <Table
                    columns={columns}
                    dataSource={UAdataSource}
                    pagination={false}
                    showHeader={false}
                    bordered={true}
                    size="middle"
                    style={{ borderRadius: "8px" }}
                  />
                </>
              )} */}

              {airline?.name == "Unite Airlines" && (


                <Row>
                  <Col span={24}>
                    <Flex vertical gap={16} className="zl-summary-detail">
                      <Flex
                        vertical
                        gap={12}
                        className="zl-company-info"
                        style={{ padding: "16px" }}
                      >
                        <Flex gap={24}>
                          {/* email  */}
                          <Flex vertical gap={4} style={{ flex: "1" }}>
                            <CustomTitle
                              text="Email"
                              fontSize="12px"
                              fontWeight="600"
                              lineHeight="16px"
                              color="black"
                              marginBottom="0"
                              marginTop="0"
                            />
                            <CustomTitle
                              text={data?.email || "--"}
                              fontSize="12px"
                              fontWeight="400"
                              lineHeight="20px"
                              color="#4B4B4B"
                              marginBottom="0"
                              marginTop="0"
                            />
                          </Flex>
                          {/* sales email  */}
                          <Flex vertical gap={4} style={{ flex: "1" }}>
                            <CustomTitle
                              text="Sales email"
                              fontSize="12px"
                              fontWeight="600"
                              lineHeight="16px"
                              color="black"
                              marginBottom="0"
                              marginTop="0"
                            />
                            <CustomTitle
                              text={data?.portCode || "--"}
                              fontSize="12px"
                              fontWeight="400"
                              lineHeight="20px"
                              color="#4B4B4B"
                              marginBottom="0"
                              marginTop="0"
                            />
                          </Flex>
                          {/* phone 1 */}
                          <Flex vertical gap={4} style={{ flex: "1" }}>
                            <CustomTitle
                              text="Phone 1"
                              fontSize="12px"
                              fontWeight="600"
                              lineHeight="16px"
                              color="black"
                              marginBottom="0"
                              marginTop="0"
                            />
                            <CustomTitle
                              text={data?.portCode || "--"}
                              fontSize="12px"
                              fontWeight="400"
                              lineHeight="20px"
                              color="#4B4B4B"
                              marginBottom="0"
                              marginTop="0"
                            />
                          </Flex>
                          {/* phone 2 */}
                          <Flex vertical gap={4} style={{ flex: "1" }}>
                            <CustomTitle
                              text="Phone 2"
                              fontSize="12px"
                              fontWeight="600"
                              lineHeight="16px"
                              color="black"
                              marginBottom="0"
                              marginTop="0"
                            />
                            <CustomTitle
                              text={data?.portCode || "--"}
                              fontSize="12px"
                              fontWeight="400"
                              lineHeight="20px"
                              color="#4B4B4B"
                              marginBottom="0"
                              marginTop="0"
                            />
                          </Flex>
                        </Flex>
                        {/* Firms code  */}
                        <Flex gap={24}>
                          {/* Firms code  */}
                          <Flex vertical gap={4} style={{ flex: "1" }}>
                            <CustomTitle
                              text="Firms code"
                              fontSize="12px"
                              fontWeight="600"
                              lineHeight="16px"
                              color="black"
                              marginBottom="0"
                              marginTop="0"
                            />
                            <CustomTitle
                              text={data?.portCode || "--"}
                              fontSize="12px"
                              fontWeight="400"
                              lineHeight="20px"
                              color="#4B4B4B"
                              marginBottom="0"
                              marginTop="0"
                            />
                          </Flex>
                        </Flex>
                      </Flex>
                    </Flex>
                  </Col>
                </Row>
              )}

            </Flex>
          </Flex>
        </Col>

        {/* right side map and address  */}

        <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
          <Flex vertical gap={16} className="zl-summary-detail">
            <Link
              to={`/contact/${airlineName}/company-contact`}
              state={{ airport, airline }}
              className="zl-company-contact"
              style={{ gap: "16px", justifyContent: "flex-start" }}
            >
             {contactsList?.length < 1 && <PlusIcon fill="#5E5E5E" width={24} height={24} className="" /> }
             <Flex style={{justifyContent:'space-between', width:'100%'}}>

              <CustomTitle
                text={contactsList?.length > 0 ? `${contactsList?.length} company contacts` : 'Add company contacts'}
                fontSize="16px"
                fontWeight="600"
                lineHeight="24px"
                color="black"
                marginBottom="0"
                marginTop="0"
              />

             {contactsList?.length > 0 &&<ChevronRightIcon fill="#5E5E5E" width={24} height={24} className="" /> }
                </Flex>
            </Link>
            <Flex vertical gap={24} className="zl-company-info">
              {/* <img src={map} alt="" className="zl-company-map" /> */}
              <GoogleMapsProvider>
                <div style={containerStyle}>
                  <GoogleMap
                    mapContainerStyle={{ width: "100%", height: "100%" }}
                    center={center}
                    zoom={12}
                  >
                    <Marker position={center} />
                  </GoogleMap>
                </div>
              </GoogleMapsProvider>
              <Flex vertical gap={24} className="zl-company-detail">
                <Flex vertical gap={4}>
                  <CustomTitle
                    text={airline?.name == 'United Airlines' ? 'Facility address' : data?.address?.locationType}
                    fontSize="16px"
                    fontWeight="600"
                    lineHeight="20px"
                    color="black"
                    marginBottom="0"
                    marginTop="0"
                  />
                  <div style={{ maxWidth: '180px' }}>

                    <CustomTitle
                      text={data?.address?.locationAddress}
                      fontSize="12px"
                      fontWeight="400"
                      lineHeight="20px"
                      color="#4B4B4B"
                      marginBottom="0"
                      marginTop="0"
                    />
                  </div>
                </Flex>

                {/* contact info in sidebar  */}

                {airline?.name == "United Airlines" && (
                  <>
                    <CustomTitle
                      text="Contact Info"
                      fontSize="16px"
                      fontWeight="600"
                      lineHeight="20px"
                      color="black"
                      marginBottom="0"
                      marginTop="0"
                    />

                    <Row>
                      <Col span={24}>
                        <Flex vertical gap={16} className="zl-summary-detail">
                          <Row gutter={[24, 24]}>
                            {/* Email */}
                            <Col span={12}>
                              <Flex vertical gap={4}>
                                <CustomTitle
                                  text="Email"
                                  fontSize="12px"
                                  fontWeight="600"
                                  lineHeight="16px"
                                  color="black"
                                  marginBottom="0"
                                  marginTop="0"
                                />
                                <CustomTitle
                                  text={UAdata?.contactInfo?.Email || "--"}
                                  fontSize="12px"
                                  fontWeight="400"
                                  lineHeight="20px"
                                  color="#4B4B4B"
                                  marginBottom="0"
                                  marginTop="0"
                                />
                              </Flex>
                            </Col>

                            {/* Sales Email */}
                            <Col span={12}>
                              <Flex vertical gap={4}>
                                <CustomTitle
                                  text="Sales Email"
                                  fontSize="12px"
                                  fontWeight="600"
                                  lineHeight="16px"
                                  color="black"
                                  marginBottom="0"
                                  marginTop="0"
                                />
                                <CustomTitle
                                  text={UAdata?.contactInfo?.Sales_email || UAdata?.contactInfo?.Sales_Email || "--"}
                                  fontSize="12px"
                                  fontWeight="400"
                                  lineHeight="20px"
                                  color="#4B4B4B"
                                  marginBottom="0"
                                  marginTop="0"
                                />
                              </Flex>
                            </Col>

                            {/* Phone 1 */}
                            <Col span={12}>
                              <Flex vertical gap={4}>
                                <CustomTitle
                                  text="Phone 1"
                                  fontSize="12px"
                                  fontWeight="600"
                                  lineHeight="16px"
                                  color="black"
                                  marginBottom="0"
                                  marginTop="0"
                                />
                                <CustomTitle
                                  text={UAdata?.contactInfo?.Phone || "--"}
                                  fontSize="12px"
                                  fontWeight="400"
                                  lineHeight="20px"
                                  color="#4B4B4B"
                                  marginBottom="0"
                                  marginTop="0"
                                />
                              </Flex>
                            </Col>

                            {/* Phone 2 */}
                            <Col span={12}>
                              <Flex vertical gap={4}>
                                <CustomTitle
                                  text="Phone 2"
                                  fontSize="12px"
                                  fontWeight="600"
                                  lineHeight="16px"
                                  color="black"
                                  marginBottom="0"
                                  marginTop="0"
                                />
                                <CustomTitle
                                  text={UAdata?.contactInfo?.Sales_Phone || "--"}
                                  fontSize="12px"
                                  fontWeight="400"
                                  lineHeight="20px"
                                  color="#4B4B4B"
                                  marginBottom="0"
                                  marginTop="0"
                                />
                              </Flex>
                            </Col>

                            {/* Firms Code */}
                            <Col span={12}>
                              <Flex vertical gap={4}>
                                <CustomTitle
                                  text="Firms Code"
                                  fontSize="12px"
                                  fontWeight="600"
                                  lineHeight="16px"
                                  color="black"
                                  marginBottom="0"
                                  marginTop="0"
                                />
                                <CustomTitle
                                  text={UAdata?.contactInfo?.FIRMS_Code || "--"}
                                  fontSize="12px"
                                  fontWeight="400"
                                  lineHeight="20px"
                                  color="#4B4B4B"
                                  marginBottom="0"
                                  marginTop="0"
                                />
                              </Flex>
                            </Col>
                          </Row>
                        </Flex>
                      </Col>
                    </Row>


                  </>
                )}
                {/* contact info in sidebar end */}


                <Flex vertical gap={16}>
                  <CustomTitle
                    text="Customs"
                    fontSize="16px"
                    fontWeight="600"
                    lineHeight="20px"
                    color="black"
                    marginBottom="0"
                    marginTop="0"
                  />

                  <Row gutter={[40, 24]} justify="space-between">
                    {airline?.name == 'United Airlines' &&
                      <Col xs={24} sm={12} md={12}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                          <CustomTitle
                            text="Port code"
                            fontSize="12px"
                            fontWeight="600"
                            lineHeight="16px"
                            color="black"
                            marginBottom="0"
                            marginTop="0"
                          />
                          <CustomTitle
                            text={data?.tabData?.facilityAddress || "--"}
                            fontSize="12px"
                            fontWeight="400"
                            lineHeight="20px"
                            color="#4B4B4B"
                            marginBottom="0"
                            marginTop="0"
                          />
                        </div>
                      </Col>}

                    <Col xs={24} sm={12} md={12}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <CustomTitle
                          text="Port code"
                          fontSize="12px"
                          fontWeight="600"
                          lineHeight="16px"
                          color="black"
                          marginBottom="0"
                          marginTop="0"
                        />
                        <CustomTitle
                          text={data?.firmsCode || "--"}
                          fontSize="12px"
                          fontWeight="400"
                          lineHeight="20px"
                          color="#4B4B4B"
                          marginBottom="0"
                          marginTop="0"
                        />
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={12}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <CustomTitle
                          text="FIRMS code"
                          fontSize="12px"
                          fontWeight="600"
                          lineHeight="16px"
                          color="black"
                          marginBottom="0"
                          marginTop="0"
                        />
                        <CustomTitle
                          text={data?.portCode || "--"}
                          fontSize="12px"
                          fontWeight="400"
                          lineHeight="20px"
                          color="#4B4B4B"
                          marginBottom="0"
                          marginTop="0"
                        />
                      </div>
                    </Col>
                  </Row>


                  {data?.IRS_Number && (
                    <Flex vertical gap={4} style={{ flex: "1" }}>
                      <CustomTitle
                        text="AA/IRS Number"
                        fontSize="12px"
                        fontWeight="600"
                        lineHeight="16px"
                        color="black"
                        marginBottom="0"
                        marginTop="0"
                      />
                      <CustomTitle
                        text={data?.IRS_Number}
                        fontSize="12px"
                        fontWeight="400"
                        lineHeight="20px"
                        color="#4B4B4B"
                        marginBottom="0"
                        marginTop="0"
                      />
                    </Flex>
                  )}

                  {data?.phone_number && (
                    <Flex vertical gap={4} style={{ flex: "1" }}>
                      <CustomTitle
                        text="Phone"
                        fontSize="12px"
                        fontWeight="600"
                        lineHeight="16px"
                        color="black"
                        marginBottom="0"
                        marginTop="0"
                      />
                      <CustomTitle
                        text={data?.phone_number}
                        fontSize="12px"
                        fontWeight="400"
                        lineHeight="20px"
                        color="#4B4B4B"
                        marginBottom="0"
                        marginTop="0"
                      />
                    </Flex>
                  )}
                </Flex>
                <Flex vertical gap={8}>
                  <CustomTitle
                    text="Facilities"
                    fontSize="16px"
                    fontWeight="600"
                    lineHeight="20px"
                    color="black"
                    marginBottom="0"
                    marginTop="0"
                  />
                  {data?.facilityInfo?.length > 0 ? (
                    <ul className="zl-facility-list">
                      {data?.facilityInfo?.map((data, index) => (
                        <>
                          {data?.indicator == "Yes" && (
                            <li>{data?.attributes}</li>
                          )}
                        </>
                      ))}
                      {/* <li>Security cage</li>
                    <li>Hi-value storage</li>
                    <li>Cooler</li>
                    <li>Import fee 512B</li>
                    <li>Storage fee 512B</li> */}
                    </ul>
                  ) : (
                    <p>N/A</p>
                  )}
                </Flex>
              </Flex>
            </Flex>
          </Flex>
          <p className="zl-page-content">
            The data on this page is sourced from third-party websites and may
            be outdated or inaccurate. Always verify details with the official
            website.
          </p>
        </Col>
      </Row>

      {airline?.name == "American Airlines" && (
        <Flex gap={12} vertical style={{ marginTop: "10px" }}>
          <CustomTitle
            text="PPS Policies"
            fontSize="16px"
            fontWeight="600"
            lineHeight="20px"
            color="black"
            marginBottom="0"
            marginTop="0"
          />
          <Alert
            className="zl-custom-warning-message"
            style={{ width: "fit-content" }}
            message="Overnight drop-off is not permitted."
            type="warning"
            showIcon
            icon={<WarningIcon fill="black" width={24} height={24} />}
          />
        </Flex>
      )}
      {/* <Drawer
        className="zl-custom-drawer"
        title="Summary"
        placement="right"
        open={summaryDrawerOpen}
        onClose={() => setSummaryDrawerOpen(false)}
      >
        <Flex vertical gap={16}>
          <Link
            to={`/${airlineName}/company-contact`}
            state={{ airport, airline }}
            className="zl-company-contact"
            style={{ gap: "16px", justifyContent: "flex-start" }}
          >
            <PlusIcon fill="#5E5E5E" width={24} height={24} className="" />
            <CustomTitle
              text="Add company contacts"
              fontSize="16px"
              fontWeight="600"
              lineHeight="20px"
              color="black"
              marginBottom="0"
              marginTop="0"
            />
          </Link>

           <Flex vertical gap={24} className="zl-company-info">
            <img src={map} alt="" className="zl-company-map" />
            <Flex vertical gap={24} className="zl-company-detail">
              <Flex vertical gap={4}>
                <CustomTitle
                  text="Facility address"
                  fontSize="16px"
                  fontWeight="600"
                  lineHeight="20px"
                  color="black"
                  marginBottom="0"
                  marginTop="0"
                />
                <CustomTitle
                  text="There are multiple facility addresses at this airport."
                  fontSize="12px"
                  fontWeight="400"
                  lineHeight="20px"
                  color="#4B4B4B"
                  marginBottom="0"
                  marginTop="0"
                />
              </Flex>
              <Flex vertical gap={16}>
                <CustomTitle
                  text="Customs"
                  fontSize="16px"
                  fontWeight="600"
                  lineHeight="20px"
                  color="black"
                  marginBottom="0"
                  marginTop="0"
                />

                <Flex gap={40} wrap justify="space-between">
                  <Flex vertical gap={4} style={{ flex: "1" }}>
                    <CustomTitle
                      text="Port code"
                      fontSize="12px"
                      fontWeight="600"
                      lineHeight="16px"
                      color="black"
                      marginBottom="0"
                      marginTop="0"
                    />
                    <CustomTitle
                      text="2801"
                      fontSize="12px"
                      fontWeight="400"
                      lineHeight="20px"
                      color="#4B4B4B"
                      marginBottom="0"
                      marginTop="0"
                    />
                  </Flex>
                  <Flex vertical gap={4} style={{ flex: "1" }}>
                    <CustomTitle
                      text="FIRMS code"
                      fontSize="12px"
                      fontWeight="600"
                      lineHeight="16px"
                      color="black"
                      marginBottom="0"
                      marginTop="0"
                    />
                    <CustomTitle
                      text="W697"
                      fontSize="12px"
                      fontWeight="400"
                      lineHeight="20px"
                      color="#4B4B4B"
                      marginBottom="0"
                      marginTop="0"
                    />
                  </Flex>
                </Flex>
                <Flex vertical gap={4} style={{ flex: "1" }}>
                  <CustomTitle
                    text="AA/IRS Number"
                    fontSize="12px"
                    fontWeight="600"
                    lineHeight="16px"
                    color="black"
                    marginBottom="0"
                    marginTop="0"
                  />
                  <CustomTitle
                    text="2720"
                    fontSize="12px"
                    fontWeight="400"
                    lineHeight="20px"
                    color="#4B4B4B"
                    marginBottom="0"
                    marginTop="0"
                  />
                </Flex>
              </Flex>

              <Flex vertical gap={8}>
                <CustomTitle
                  text="Facilities"
                  fontSize="16px"
                  fontWeight="600"
                  lineHeight="20px"
                  color="black"
                  marginBottom="0"
                  marginTop="0"
                />
                <ul className="zl-facility-list">
                  <li>DASH</li>
                  <li>Security cage</li>
                  <li>Hi-value storage</li>
                  <li>Cooler</li>
                  <li>Import fee 512B</li>
                  <li>Storage fee 512B</li>
                </ul>
              </Flex>
            </Flex>
          </Flex>  
        </Flex>
      </Drawer> */}
    </section>
  );
};

export default DeltaAirline;
